import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  Module,
  SaveModule,
  ISaveModule,
  SeriesItem,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import ModuleForm from "./ModuleForm";

type ModuleUpdateFormProps = {
  module: Module;
  onModuleUpdated: () => void;
  onCancel: () => void;
  series: SeriesItem;
};

const ModuleUpdateForm = ({
  module,
  onModuleUpdated,
  onCancel,
  series,
}: ModuleUpdateFormProps) => {
  const { formatMessage: t } = useIntl();
  const { seriesService } = useGlobalContext();

  const onSubmit = async (values: ISaveModule) => {
    try {
      await seriesService.saveModule(series.id, new SaveModule(values));
      onModuleUpdated();
    } catch (err) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <ModuleForm
      module={module}
      onCancel={onCancel}
      onSubmit={onSubmit}
      series={series}
      isEdit={true}
      submitLabel={t({ id: "moduleFormUpdateButton" })}
    />
  );
};

export default ModuleUpdateForm;
